import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class LabMeasurementReaderFieldEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.tag_name = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.category = null;
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.expression = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.sampling_point = null;
		/** @type {string} */
		this.analysis = null;
		/** @type {Object} */
		this.component_map = null;
		/** @type {string} */
		this.component = null;
	}

	/**
	 * @typedef {Object} _LabMeasurementReaderFieldEditDtoProps
	 * @property {string} tag_name
	 * @property {string} uom
	 * @property {string} category
	 * @property {string} type
	 * @property {string} expression
	 * @property {string} value
	 * @property {string} sampling_point
	 * @property {string} analysis
	 * @property {Object} component_map
	 * @property {string} component
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LabMeasurementReaderFieldEditDtoProps} LabMeasurementReaderFieldEditDtoProps
	 */
	/**
	 *
	 * @param {LabMeasurementReaderFieldEditDtoProps} props
	 * @returns {LabMeasurementReaderFieldEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.tag_name = props.tag_name;
		this.uom = props.uom;
		this.category = props.category;
		this.type = props.type;
		this.expression = props.expression;
		this.sampling_point = props.sampling_point;
		this.analysis = props.analysis;
		this.value = props.value;
		this.component_map = props.component_map;
		this.component = props.component;
		return this;
	}
}
